import { t as __exportAll } from "../rolldown-runtime-CNktS9qV.mjs";
import axios from "axios";
import { stringify } from "qs";
//#region src/pipeline-audit-persister/client.ts
const axiosInstance = axios.create({ paramsSerializer: { serialize: (params) => stringify(params, { arrayFormat: "repeat" }) } });
function initHTTPClient(baseURL, onRequest, onRejectedResponse) {
	axiosInstance.defaults.baseURL = baseURL;
	if (onRequest) axiosInstance.interceptors.request.use(onRequest);
	if (onRejectedResponse) axiosInstance.interceptors.response.use((response) => response, onRejectedResponse);
	return axiosInstance;
}
const axiosClient = async (config) => {
	return axiosInstance.request({ ...config }).catch((e) => {
		throw e;
	});
};
//#endregion
//#region src/pipeline-audit-persister/gen/models/PipelineAuditEvent.ts
const PipelineAuditEventChannelName = { IMMO24: "IMMO24" };
const PipelineAuditEventChannelName2 = { GEOMAP: "GEOMAP" };
const PipelineAuditEventChannelName3 = { PRICEHUBBLE: "PRICEHUBBLE" };
const PipelineAuditEventChannelName4 = { TRANSACTION_TEAM: "TRANSACTION_TEAM" };
const PipelineAuditEventChannelName5 = { GPT: "GPT" };
const PipelineAuditEventReasonCode = { DUPLICATED: "DUPLICATED" };
const PipelineAuditEventReasonCode2 = { IRRELEVANT: "IRRELEVANT" };
const PipelineAuditEventReasonCode3 = { IGNORED_UPDATE: "IGNORED_UPDATE" };
const PipelineAuditEventReasonCode4 = { DATA_RETRIEVAL_ERROR: "DATA_RETRIEVAL_ERROR" };
const PipelineAuditEventReasonCode5 = { UNKNOWN_ERROR: "UNKNOWN_ERROR" };
//#endregion
//#region src/pipeline-audit-persister/gen/models/pipelineAuditEventsModels/GetPipelineAuditEvents.ts
const GetPipelineAuditEventsQueryParamsChannelName = { IMMO24: "IMMO24" };
const GetPipelineAuditEventsQueryParamsChannelName2 = { GEOMAP: "GEOMAP" };
const GetPipelineAuditEventsQueryParamsChannelName3 = { PRICEHUBBLE: "PRICEHUBBLE" };
const GetPipelineAuditEventsQueryParamsChannelName4 = { TRANSACTION_TEAM: "TRANSACTION_TEAM" };
const GetPipelineAuditEventsQueryParamsChannelName5 = { GPT: "GPT" };
//#endregion
//#region src/pipeline-audit-persister/gen/clients/axios.ts
var axios_exports = /* @__PURE__ */ __exportAll({
	getPipelineAuditEvents: () => getPipelineAuditEvents,
	operations: () => operations
});
/**
* @description Get pipeline audit events filtered by originalId and channelName
* @link /api/pipeline-audit-events
*/
async function getPipelineAuditEvents(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/pipeline-audit-events`,
		params,
		...options
	})).data;
}
const operations = { getPipelineAuditEvents: {
	path: "/api/pipeline-audit-events",
	method: "get"
} };
//#endregion
//#region src/pipeline-audit-persister/gen/clients/axios-class-client.ts
var PipelineAuditPersisterSdk = class {
	client;
	constructor(client) {
		this.client = client;
	}
	async axiosClient(config) {
		return this.client.request({ ...config }).catch((e) => {
			throw e;
		});
	}
	/**
	* @description Get pipeline audit events filtered by originalId and channelName
	* @link /api/pipeline-audit-events
	*/
	async getPipelineAuditEvents(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/pipeline-audit-events`,
			params,
			...options
		})).data;
	}
};
//#endregion
export { GetPipelineAuditEventsQueryParamsChannelName, GetPipelineAuditEventsQueryParamsChannelName2, GetPipelineAuditEventsQueryParamsChannelName3, GetPipelineAuditEventsQueryParamsChannelName4, GetPipelineAuditEventsQueryParamsChannelName5, PipelineAuditEventChannelName, PipelineAuditEventChannelName2, PipelineAuditEventChannelName3, PipelineAuditEventChannelName4, PipelineAuditEventChannelName5, PipelineAuditEventReasonCode, PipelineAuditEventReasonCode2, PipelineAuditEventReasonCode3, PipelineAuditEventReasonCode4, PipelineAuditEventReasonCode5, PipelineAuditPersisterSdk, initHTTPClient as initPipelineAuditPersisterHTTPClient, axios_exports as pipelineAuditPersisterApi };
